import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useCreateEditEventFlowStore } from '~admin/store/create-edit-event-flow-store-provider';
import { streaming } from '~admin/view/components/details/event-details/event-details.helper';
import { CheckboxField } from '~admin/view/components/ui/form/fields/field-checkbox.component';
import { NumberField } from '~admin/view/components/ui/form/fields/field-number.component';
import { SelectField } from '~admin/view/components/ui/form/fields/field-select.component';
import { TextField } from '~common/components/form/field-text.component';
import { Currency } from '~client/model/currency';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { getSupportedCurrencies } from '~common/helper/currency';
import { optionArrayMapper } from '~common/components/select.helper';
import {
  TranslationField,
  TranslationFormData,
} from '~admin/view/components/ui/form/fields/field-translation.component';

export interface EventOptionsFormData {
  ticketLimit: number;
  currency: Currency;
  vanityName: string;
  liveStreamReplay?: number;
  isPrivateEvent?: boolean;
  facebookPixelId?: string;
  externalNotificationSubscriptionsId: number;
  externalNotificationSubscriptionsText: TranslationFormData<string>[];
}

export const EventOptionsDetails: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const createEventFlowStore = useCreateEditEventFlowStore();
  const { eventAccessibilityType, isEdit } = createEventFlowStore;

  return (
    <Container>
      <Box>
        <RestrictBox>
          <NumberField
            name={'ticketLimit'}
            label={t('createEvent.eventDetails.options.ticketLimit')}
          />
        </RestrictBox>
        <RestrictBox>
          <SelectField
            name={'currency'}
            label={t('createEvent.eventDetails.options.currency')}
            options={optionArrayMapper(getSupportedCurrencies())}
            disabled={isEdit}
          />
        </RestrictBox>
      </Box>
      <Box>
        <RestrictBox>
          <TextField
            name={'vanityName'}
            label={t('createEvent.eventDetails.options.vanityName')}
            disabled={isEdit}
          />
        </RestrictBox>
        {streaming(eventAccessibilityType) && (
          <RestrictBox>
            <NumberField
              name={'liveStreamReplay'}
              label={t('createEvent.eventDetails.options.liveStreamReplay')}
              disabled={isEdit}
            />
          </RestrictBox>
        )}
        <CheckboxBox>
          <CheckboxField
            name={'isPrivateEvent'}
            label={t('createEvent.eventDetails.options.private')}
            disabled={isEdit}
          />
        </CheckboxBox>
      </Box>
      <RestrictBox>
        <TextField
          name={'facebookPixelId'}
          label={t('createEvent.eventDetails.options.facebookPixelId')}
        />
      </RestrictBox>
      <RestrictBox>
        <TranslationField
          name={'externalNotificationSubscriptionsText'}
          label={t('createEvent.eventDetails.options.externalSubscriptions')}
          render={(renderProps): ReactNode => <TextField {...renderProps} />}
        />
      </RestrictBox>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
  margin: 0 12px;
`;

const CheckboxBox = styled(RestrictBox)`
  max-width: 190px;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-options-details.component.tsx